import React from "react";
import GiveawayManager from "./GiveAwayManager";

const DashboardReward = () => {
  return <GiveawayManager />;
};

export default DashboardReward;
